<template>
<div class="container-fluid flex-fill" v-if="$parent.loaded">

  <b-breadcrumb>
    <b-breadcrumb-item to="/"><b-img class="mb-1" width="32" height="32" src="/static/images/logo.png" alt="logo"></b-img></b-breadcrumb-item>
    <b-breadcrumb-item active class="font-weight-bold">Remerciement</b-breadcrumb-item>
  </b-breadcrumb>

  <h5 class="text-uppercase">Les assocations qui nous soutiennent</h5>
  <ul>
    <li>CSGR <a href="https://www.tirsportifrennes.fr/" target="_blank">https://www.tirsportifrennes.fr/</a></li>
  </ul>

  <h5 class="text-uppercase">Graphisme</h5>
  <ul>
    <li>Logo du site: Sarah FENRICH</li>
  </ul>

</div>
</template>

<script>
export default {
  data: function () {
    return {

    }
  },
  methods: {
  },
  beforeMount() {
    this.$parent.init();
    document.title = this.$parent.websiteName + " - Remerciements";

    this.$parent.loaded = true;
  }
}
</script>
